// Composant responsive qui bascule automatiquement entre desktop et mobile pour l'interface Élève
import React from "react";
import { useExplanationResponsive } from "../../../hooks/useResponsive";
import StudentExplanations from "./index";
import MobileStudentExplanations from "./MobileStudentExplanations";

const ResponsiveStudentExplanations: React.FC = () => {
  const { shouldUseMobileLayout } = useExplanationResponsive();

  // Basculer automatiquement entre les versions desktop et mobile
  if (shouldUseMobileLayout) {
    return <MobileStudentExplanations />;
  }

  return <StudentExplanations />;
};

export default ResponsiveStudentExplanations;
